import type React from 'react';

import type { Lists } from '@vlabs/api/luna-api/model';
import { ListsPreview } from '@vlabs/monokit/shared/ui/person-card/lists-preview';
import { selectLists } from '@vlabs/shared/selectors/listSelectors';
import { useSelector } from 'react-redux';

interface ListsCellProps {
  lists: Lists;
}

function ListsCell({
  lists,
}: ListsCellProps): React.JSX.Element | string | null {
  const cachedLists = useSelector(selectLists);

  if (lists === undefined || lists.length === 0) return null;

  const items = lists.map(
    (list) => (cachedLists.byId[list]?.user_data?.length > 0 ? cachedLists.byId[list]?.user_data : list) as string,
  );

  return (
    <ListsPreview
      items={items}
      tooltipPlacement="top"
    />
  );
}

export { ListsCell };
